
import _ from "lodash";
import { DateTime } from "luxon";

import { useParams, useRouteLoaderData } from "react-router";
import { useEffect, useState } from "react";
import SetMenuCard, { SetMenuItem } from "../component/SetMenuCard";
import { Spinner } from "react-bootstrap";

import server from "../server";
import NotFound from "./NotFound";
import { CampaignLoaderData } from "../Loader/compaignLoader";

type TimeSlot = {
  dates: string[];
  startAt: string;
  endAt: string;
  interval: number;
};

type SetMenu = {
  id: number;
  attributes: {
    shops: any;
    user_max_quantity: number | undefined;
    title: string;
    description: string;
    sort_order: number;
    active: boolean;
    start_date: string;
    end_date: string;
    time_slots: TimeSlot[];
    cuisines: any[];
  };
  countingSetMenu?: number;
};
export default function SetMenuList() {
  const [loadingMenus, setLoadingMenus] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [setMenuList, setSetMenuList] = useState<SetMenu[]>([]);
  const { company: companyParam } = useParams();
  const loaderData = useRouteLoaderData("company-root") as CampaignLoaderData | undefined;
  const campaign = loaderData?.campaign ?? null;
  const campaignError = loaderData?.campaignError ?? null;

  useEffect(() => {
    if (!campaign) return;
    let disposed = false;

    const buildSetMenuList = async () => {
      setLoadingMenus(true);
      try {
        const menusRes = campaign?.attributes?.setmenus?.data;
        console.log("Fetched set menus:", menusRes);
        const now = DateTime.now().setZone("Asia/Hong_Kong");
        const todayString = now.toISODate();
        const menu = menusRes
          .map((v) => ({
            ...v,
            attributes: {
              ...v.attributes,
            },
          }))
          .filter((setMenu) => setMenu?.attributes?.active)
          .filter((setMenu) => {
            const timeSlots = setMenu?.attributes?.time_slots;

            if (!todayString || !timeSlots?.length) return false;

            return timeSlots.some((slot: TimeSlot) => {
              const dates = slot?.dates || [];

              // Campaign menus stay listed for the whole day, regardless of slot times.
              return dates.some((date: string) => {
                const slotDate = DateTime.fromISO(date, { zone: "Asia/Hong_Kong" })
                  .startOf("day")
                  .toISODate();
                return !!slotDate && slotDate >= todayString;
              });
            });
          })
          .filter((setMenu) => {
            const start = DateTime.fromISO(setMenu?.attributes?.start_date, {
              zone: "Asia/Hong_Kong",
            }).startOf("day");
            const end = DateTime.fromISO(setMenu?.attributes?.end_date, {
              zone: "Asia/Hong_Kong",
            }).endOf("day");
            return now >= start && now <= end;
          });

        const setMenuPromises = menu.map(async (v: { id: any; attributes: any }) => {
          const userSetMenu = await server.findAll("user-campaign-setmenus", {
            filters: {
              // user: { id: { $null: true } },
              email: { $null: true },
              phone: { $null: true },
              setmenu: v?.id,
            },
          });

          return {
            ...v,
            countingSetMenu: userSetMenu?.length || 0,
          };
        });

        const resolvedSetMenuList = await Promise.all(setMenuPromises);

        if (!disposed) {
          setSetMenuList(_.sortBy(resolvedSetMenuList, (v) => v?.attributes?.sort_order));
        }
      } catch (err) {
        console.error("Failed to build set menu list:", err);
        if (!disposed) setError("Failed to load set menus. Please try again later.");
        if (!disposed) setSetMenuList([]);
      } finally {
        if (!disposed) setLoadingMenus(false);
      }
    };

    void buildSetMenuList();

    return () => {
      disposed = true;
    };
  }, [campaign]);
  if (!companyParam || !campaign) {
    return (<NotFound />);
  }
  return (
    <main
      style={{
        minHeight: "100vh",
        backgroundColor: "#f8f7f5",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* <CartButton counting={0} /> */}

      <div
        style={{
          flex: 1,
          marginBottom: 25,
          paddingLeft: 16,
          paddingRight: 16,
          overflowY: "auto",
        }}
      >

        {(loadingMenus) && (
          <div
            style={{
              width: "100%",
              // minHeight: "40vh",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        )}
        {/* 
        {!loadingMenus && loadingBrands && (
          <p style={{ textAlign: "center", color: "#6A6A6A" }}>Loading brands...</p>
        )} */}

        {error && (
          <p style={{ textAlign: "center", color: "red" }}>{error}</p>
        )}

        <div
          style={{
            width: "100%",
            maxWidth: 1280,
            margin: "0 auto",
            paddingBottom: 100,
          }}
        >
          <div className="row g-3 justify-content-center">
            {!loadingMenus && setMenuList.length === 0 && (
              <div className="col-12">
                <p style={{ color: "#6A6A6A", textAlign: "center", margin: 0 }}>
                  暫時沒有套餐可用。請稍後再查。
                </p>
              </div>
            )}

            {setMenuList.map((item: SetMenuItem) => (
              <div key={item.id} className="col-12 col-md-6 col-xl-4 d-flex justify-content-center">
                <div style={{ width: "100%", maxWidth: 420 }}>
                  <SetMenuCard
                    item={{
                      id: item.id,
                      countingSetMenu: item.countingSetMenu,
                      attributes: item.attributes,
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
}
